import React from 'react';
import { motion } from 'framer-motion';
const BEDROOM_IMAGE = 'https://cdn.magicpatterns.com/uploads/eL3cZCxFqXPzZ1PcKNsJiB/HABITACION.webp';
const MARBLE_IMAGE = 'https://cdn.magicpatterns.com/uploads/2hvUvmPnBN6RhWzKhVUQoE/marmoldetalle.webp';
const ALLY_ACTION_IMAGE = 'https://cdn.magicpatterns.com/uploads/rEuFAQBpHwaGaXi9t8csCF/allylimpiando.webp';
interface GalleryImageProps {
  src: string;
  alt: string;
  caption?: string;
  className: string;
  delay: number;
  aspectClass?: string;
  imageClass?: string;
}
const PENTHOUSE_LIGHTING_IMAGE = 'https://cdn.magicpatterns.com/uploads/adKBfCnkHpuYXGGvgA8Rvq/Limpieza1.webp';
const PENTHOUSE_KITCHEN_IMAGE = 'https://cdn.magicpatterns.com/uploads/9fsJ8EaZnZC28qPzhcRimo/Limpieza2.webp';
export function ExcellenceGallery() {
  return <section aria-labelledby="excellence-heading" className="w-full bg-white" data-id="element-35" data-mp="1b099521got1k">
      <div className="mx-auto max-w-7xl px-5 py-24 sm:px-8" data-id="element-36" data-mp="1604ttfcai4cx">
        <div className="grid gap-12 lg:grid-cols-12 lg:items-start lg:gap-16" data-id="element-37" data-mp="15yjvdemuu19s">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.55
        }} className="lg:col-span-4 lg:sticky lg:top-28" data-id="element-38" data-mp="2ezjzepjktt5h">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-magenta" data-id="element-39" data-mp="2a2tgzvkaulgw">
              The Ally Difference
            </p>
            <p className="mt-5 font-display text-sm font-semibold uppercase tracking-[0.18em] text-slate-muted" data-id="element-40" data-mp="2xtyx8bu5jfrq">
              The Standard of Excellence
            </p>
            <h2 id="excellence-heading" className="mt-4 font-display text-4xl font-extrabold leading-[1.08] tracking-tight text-slate sm:text-5xl" data-id="element-41" data-mp="2o19y8gfsfuda">
              More Than Cleaning. A Lifestyle of Care.
            </h2>
            <div className="mt-7 h-px w-16 bg-magenta" data-id="element-42" data-mp="3lhqn6i8m7rbh" />
            <p className="mt-7 max-w-md text-base leading-relaxed text-slate-soft" data-id="element-43" data-mp="3lja3g8u9u2d9">
              We understand that luxury isn&apos;t just about the surface—it&apos;s about the
              peace of mind that comes from knowing every corner of your home is handled
              with absolute precision. Our methods are designed for New York&apos;s high-end
              materials, from delicate Italian marble to premium upholstery. We don&apos;t
              just clean; we preserve the value and beauty of your sanctuary. Every visit
              follows our 50-point perfection checklist to ensure that when you walk
              through your door, the only thing you feel is relief.
            </p>
          </motion.div>

          <div className="grid grid-cols-2 gap-4 sm:gap-5 lg:col-span-8 lg:grid-cols-4" data-id="element-44" data-mp="2yn6k7cu4xghl">
            <GalleryImage src={BEDROOM_IMAGE} alt="Immaculately made luxury bedroom with crisp white linens and city views" caption="Restful Sanctuaries" className="col-span-2" aspectClass="aspect-[16/9]" delay={0.05} data-id="element-45" data-mp="2tnty4ub38dg2" />
            <GalleryImage src={MARBLE_IMAGE} alt="A gloved hand carefully cleaning a polished marble countertop" caption="Specialized Surface Care" className="col-span-1" aspectClass="aspect-square" delay={0.12} data-id="element-46" data-mp="1959pdf8gmi97" />
            <GalleryImage src={ALLY_ACTION_IMAGE} alt="Ally carefully cleaning a high-end New York apartment interior" caption="The Meticulous Touch" className="col-span-1 row-span-2" aspectClass="aspect-[9/16]" imageClass="object-top" delay={0.19} data-id="element-47" data-mp="lh00g4fy9edu" />
            <GalleryImage src={PENTHOUSE_LIGHTING_IMAGE} alt="Ally meticulously cleaning a pendant light in a bright penthouse kitchen" className="col-span-1" aspectClass="aspect-square" delay={0.26} data-id="element-48" data-mp="z9g3h58upcer" />
            <GalleryImage src={PENTHOUSE_KITCHEN_IMAGE} alt="Ally carefully cleaning a statement chandelier in a luxury kitchen" className="col-span-1" aspectClass="aspect-square" delay={0.33} data-id="element-49" data-mp="3jpz95pxf4cnr" />
          </div>
        </div>
      </div>
    </section>;
}
function GalleryImage({
  src,
  alt,
  caption,
  className,
  delay,
  aspectClass = 'aspect-[4/3]',
  imageClass = ''
}: GalleryImageProps) {
  return <motion.figure initial={{
    opacity: 0,
    y: 24
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-70px'
  }} transition={{
    duration: 0.5,
    delay
  }} className={className} data-id="element-50" data-mp="1du9c152xb2r">
      <div className={`overflow-hidden rounded-2xl bg-slate-100 ${aspectClass}`} data-id="element-51" data-mp="2i2q3dtnmzy6s">
        <img src={src} alt={alt} className={`h-full w-full object-cover ${imageClass}`} data-id="element-52" data-mp="2i4u6i9dpot60" />
      </div>
      {caption && <figcaption className="mt-4 font-display text-base font-bold tracking-tight text-slate" data-id="element-53" data-mp="smx7s0ox1asc">
          {caption}
        </figcaption>}
    </motion.figure>;
}